import React, { useState, useEffect } from "react";
import "../CSS/styles.css";
import f1 from '../../assets/f1.png';
import f2 from '../../assets/f2.png';
import f3 from '../../assets/f3.png';
import f4 from '../../assets/f4.png';
import f5 from '../../assets/f5.png';
import f6 from '../../assets/f6.png';
import f7 from '../../assets/f7.png';
import f8 from '../../assets/f8.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Featured = () => {
        useEffect(() => {
          AOS.init({
            duration: 1000,
            once: false,
          });
        }, []);
  const [selectedOption, setSelectedOption] = useState("option1");

  const images = [
    { src: f1, alt: "Risk Management", showOn: ["option1", "option2"], title: "National Security Infrastructure Assessment", desc: "Comprehensive assessment and enhancement of security infrastructure for a national institution." },
    { src: f2, alt: "Crisis Management", showOn: ["option1", "option3"], title: "Corporate Crisis Response System", desc: "Development of an integrated crisis response system for a multinational corporation." },
    { src: f3, alt: "GIS", showOn: ["option1", "option6"], title: "Smart City GIS Implementation", desc: "GIS-based solution for urban planning and management in a major metropolitan area." },
    { src: f4, alt: "Cyber Security", showOn: ["option1", "option7"], title: "Enterprise Cyber Security Program", desc: "Comprehensive cyber security program development for a financial services organization." },
    { src: f5, alt: "Training", showOn: ["option1", "option8"], title: "Security Training Program", desc: "Custom security training program for an international humanitarian organization." },
    { src: f6, alt: "Digital Solutions", showOn: ["option1", "option9"], title: "Field Operations Mobile App", desc: "Secure mobile application for field operations and data collection." },
    { src: f7, alt: "Research & Analysis", showOn: ["option1", "option5"], title: "Market Entry Research Study", desc: "Comprehensive research and analysis for market entry strategy in emerging markets." },
    { src: f8, alt: "Project Support", showOn: ["option1", "option4"], title: "Critical Infrastructure Project", desc: "End-to-end project management for critical infrastructure development." },
  ];

  const radioOptions = [
    { id: "option1", label: "All Projects" },
    { id: "option2", label: "Risk Management" },
    { id: "option3", label: "Crisis Management" },
    { id: "option4", label: "Project Support" },
    { id: "option5", label: "Research & Analysis" },
    { id: "option6", label: "GIS" },
    { id: "option7", label: "Cyber Security" },
    { id: "option8", label: "Training" },
    { id: "option9", label: "Digital Solutions" },
  ];

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.id);
  };

  return (
    <div className="container inter mt-5" data-aos="fade-up">
      <div className="row py-5 justify-content-center">
        <h1 className="mb-0 bc fw-bold text-center">Featured Projects</h1>
        <p className="mb-0 mt-2 gc text-center">Explore our recent work delivering innovative solutions for clients worldwide.</p>

        <div className="d-flex flex-wrap radio-container justify-content-center mt-4 gap-2">
          {radioOptions.map(({ id, label }) => (
            <div key={id} className="d-flex align-items-center">
              <input
                type="radio"
                className="btn-check"
                name="options"
                id={id}
                autoComplete="off"
                checked={selectedOption === id}
                onChange={handleOptionChange}
              />
              <label className="btn p-2 px-3 fs-6-5 fw-medium" htmlFor={id}>
                {label}
              </label>
            </div>
          ))}
        </div>


        <div className="row mt-4">
          {images.map(({ src, alt, showOn, title, desc }, index) =>
            showOn.includes(selectedOption) ? (
              <div key={index} className="col-lg-4 col-12 mt-4">
                <div className="image-wrapper2 position-relative">
                  <img src={src} alt={alt} className="img-fluid" />
                  <div className="image-overlay2 position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center">
                    <div className="overlay-content2 ps-4 text-white">
                      <p className="wcc aa bo50 mb-0 bc fs-7 mt-3 fw-medium p-2 px-3" style={{ whiteSpace: 'nowrap' }}>{alt}</p>
                      <h4 className="wrc mb-0 mt-2 fw-semibold">{title}</h4>
                      <p className="wrc mb-0 fs-7 mt-2">{desc}</p>
                      <button className="talk px-4 py-2 mt-3">
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          )}
        </div>

      </div>
    </div>
  );
};

export default Featured;
